import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

interface TablePaginatorProps {
  totalRows: number;
  pageLength: number;
  pageNumber: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
}

function TablePaginator({
  totalRows, pageLength, pageNumber, handlePageChange,
}: TablePaginatorProps) {
  if (Math.ceil(totalRows / pageLength) <= 1) {
    return <></>;
  }
  return (
    <Stack direction="row" justifyContent="center" className="table-pagination-container">
      <Pagination
        count={Math.ceil(totalRows / pageLength)}
        page={pageNumber + 1}
        onChange={handlePageChange}
      />
    </Stack>
  );
}

TablePaginator.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  pageLength: PropTypes.number.isRequired,
  totalRows: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
};

export default TablePaginator;
